import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5af30425"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "toolbar-button-wrapper"
};
const _hoisted_2 = ["disabled"];
export default {
  __name: 'ToolbarButton',
  props: {
    icon: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _directive_tippy = _resolveDirective("tippy");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("button", {
        disabled: __props.disabled,
        class: _normalizeClass([{
          'active': __props.active,
          'disabled': __props.disabled
        }, "btn btn-square btn-sm p-1 btn-ghost"])
      }, [_createVNode(_component_SvgIcon, {
        class: "h-full w-full opacity-75",
        fill: "white",
        svgSymbolId: __props.icon
      }, null, 8, ["svgSymbolId"]), _renderSlot(_ctx.$slots, "default")], 10, _hoisted_2)), [[_directive_tippy, {
        content: __props.tooltip,
        placement: 'bottom',
        animation: 'scale-subtle',
        delay: 0,
        duration: 0
      }]])]);
    };
  }
};